













































































































































































import UserAuthority from '@/domain/security/user-authority.service';
import Contract from '@/domain/contract/entity/contract.entity';
import MainButton from '@/shared/buttons/main-button.component.vue';
import Rules from '@/shared/rules/rules';
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import JustifyService from '@/domain/justify/service/justify.service';
import { JustifyType } from '@/domain/justify/domain/justify-type.enum';
import Justify from '@/domain/justify/domain/justify.entity';
import ContractService from '@/domain/contract/service/contract.service';
import ContractCancellationDataRequest from '@/domain/contract/request/contract-cancellation-data-request.entity';
import ReasonsCancellationService from '@/domain/justify/service/reasons-cancellation.service';
import ContractInfoTabControl from '../contract-info-tab-index';

@Component({
  components: {
    VbTooltipSlot,
    MainButton,
  },
})
export default class CancellationDataComponent extends Vue {
  @Prop({ required: true })
  tabControl!: ContractInfoTabControl;

  @Prop({ required: true })
  contract!: Contract;

  @Prop({ required: true })
  userAuthority!: UserAuthority;

  @Prop({ required: true })
  businessUnitId!: string;

  @Prop({ required: false, default: false })
  loadElements!: boolean;

  $refs!: any;

  rules: Rules = new Rules();

  editModeValue: boolean = false;

  cancellationDataRequest: ContractCancellationDataRequest =
    new ContractCancellationDataRequest();

  justifications: Justify[] = [];

  loading: boolean = false;

  exemptFineValue: string = '';

  exemptFineValueIcon: string = 'mdi-information-outline';

  hintFineContract: string =
  'Informar o nome do responsável por isentar a multa.';

  reasonsCancellationList: Object[] = [];

  showAllowReasonsCancellation: boolean = false;

  reasonsCancellationNotLoaded: boolean = true;

  billLastInvoiceRules = [
    (v: boolean | null) => v === true || v === false || 'Campo obrigatório',
  ];

  created() {
    if (this.loadElements) this.getLists();
    this.loadedAllowReasonsCancellation();
  }

  hasCancellationDataRequest(): boolean {
    return this.contract.cancellationRequest.markedToExpire === true;
  }

  checkPermissionEditContract(): boolean {
    return this.userAuthority.canEditContract();
  }

  loadedAllowReasonsCancellation() {
    ReasonsCancellationService.getBusinessUnitAllowReasonsCancellation(this.businessUnitId)
      .then((response: boolean) => this.showAllowReasonsCancellation = response)
      .catch(() => this.showAllowReasonsCancellation = false);
  }

  get reasonsCancellationDisabled(): boolean {
    return !this.checkPermissionEditContract() || !this.editModeValue
  }

  get reasonsCancellationRequiredRules() {
    const isRequired = this.showAllowReasonsCancellation
      && this.reasonsCancellationList.length > 0
    return isRequired ? this.rules.empty : [];
  }

  @Watch('cancellationDataRequest.justification')
  loadReasonsCancellationList() {
    this.cancellationDataRequest.reasonsCancellation = '';
    if (this.cancellationDataRequest.justification === undefined
      || this.cancellationDataRequest.justification === null
    ) {
      this.reasonsCancellationList = [];
      return;
    }
    ReasonsCancellationService.getByJustificationId(
      this.businessUnitId,
      this.cancellationDataRequest.justification,
    )
      .then((response) => {
        let filteredResponse = response.map((item) => ({ id: item.id, name: item.name }));
        const contractReason = this.contract.cancellationRequest.reasonsCancellation;
        const justification = this.contract.cancellationRequest.justification;
        if (contractReason && contractReason.id
          && justification.id === this.cancellationDataRequest.justification
        ) {
          const exists = filteredResponse.some((r) => r.id === contractReason.id);
          if (!exists) {
            filteredResponse = [
              {
                id: contractReason.id,
                name: contractReason.name,
              },
              ...filteredResponse,
            ];
          }
        }

        this.reasonsCancellationList = filteredResponse;
      })
      .catch((err: any) => {
        this.reasonsCancellationList = [];
        VbSnackbarService.handleHttpError(err)
      });
  }

  updateFieldsDefault() {
    const { cancellationRequest } = this.contract;
    this.cancellationDataRequest.exemptFine = cancellationRequest.exemptFine;
    this.cancellationDataRequest.exemptFineApprover = cancellationRequest.exemptFineApprover;
    this.cancellationDataRequest.exemptFineValue = cancellationRequest.exemptFineValue;
    this.cancellationDataRequest.exemptContractualTerm = cancellationRequest.exemptContractualTerm;
    this.cancellationDataRequest.justification = cancellationRequest.justification?.id;
    this.cancellationDataRequest.churnResponsible = cancellationRequest.churnResponsible;
    this.cancellationDataRequest.expirationObservation = cancellationRequest.expirationObservation;
    this.cancellationDataRequest.billLastInvoice = cancellationRequest.billLastInvoice ?? false;
  }

  @Watch('contract.cancellationRequest')
  reloadFieldsOnContractLoad() {
    if (this.tabControl !== ContractInfoTabControl.SOLICITAR_CANCELAMENTO) return;
    if (this.editModeValue) return;
    this.updateFieldsDefault();
  }

  @Watch('reasonsCancellationList')
  loadedAllowReasonsCancellationValue() {
    this.cancellationDataRequest.reasonsCancellation = '';
    if (this.contract.cancellationRequest.reasonsCancellation != null
      && this.reasonsCancellationNotLoaded) {
      const reasons = this.contract.cancellationRequest.reasonsCancellation;
      this.cancellationDataRequest.reasonsCancellation = reasons.id;
      this.reasonsCancellationNotLoaded = false;
    }
  }

  enableEdition() {
    this.editModeValue = !this.editModeValue;
    if (!this.loadElements) {
      this.getLists();
    }
  }

  cancel() {
    this.editModeValue = !this.editModeValue;
  }

  clickSave() {
    if (!this.editModeValue) {
      return this.enableEdition();
    }
    if (!this.$refs.form.validate()) {
      return this;
    }
    ContractService
      .updateContractCancellationData(
        this.businessUnitId,
        this.contract.id,
        this.cancellationDataRequest,
      )
      .then(() => {
        VbSnackbarService.showSuccess('Dados de solicitação de cancelamento atualizados com sucesso')
        this.editModeValue = !this.editModeValue;
      })
      .catch(VbSnackbarService.handleHttpError)
    return this;
  }

  @Watch('tabControl')
  getLists() {
    if (this.tabControl !== ContractInfoTabControl.SOLICITAR_CANCELAMENTO) {
      return
    }
    this.loading = true;
    this.updateFieldsDefault();
    this.getJustifications();
    this.getTextFineContract();
    this.loading = false;
  }

  getJustifications() {
    JustifyService.getJustificationsByBusinessUnitAndType(
      this.businessUnitId,
      JustifyType.CONTRACT_MARKED_EXPIRE,
    )
      .then((response: Justify[]) => this.justifications = response)
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  getTextFineContract() {
    if (this.cancellationDataRequest.exemptContractualTerm === true) {
      this.exemptFineValue = 'Fora do período de carência';
      this.exemptFineValueIcon = 'mdi-information-outline';
      return;
    }
    if (this.cancellationDataRequest.exemptFine) {
      this.exemptFineValue = 'Não cobrar multa contratual'
      this.exemptFineValueIcon = 'mdi-close-circle';
      return;
    }
    this.exemptFineValue = 'Cobrar multa contratual no cancelamento?';
    this.exemptFineValueIcon = 'mdi-check-circle';
  }

  get getExemptFineValueAsCurrency() {
    return this.cancellationDataRequest.getExemptFineValueAsCurrency();
  }

  getTextButtonSave() {
    return this.editModeValue ? 'Salvar' : 'Editar';
  }
}
